<template>
	<div>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn slot="activator" color="primary" dark class="ml-3 mt-3 mb-3">Dodaj osobę do naboru</v-btn>
			<v-card>
				<v-card-title class="headline blue white--text">
					Dodaj osobę do naboru
				</v-card-title>
				<v-card-text>
					Wpisz imię i/lub nazwisko osoby, którą chcesz dodać
				</v-card-text>
				<v-card-text>
					<v-autocomplete
						v-model="model"
						:items="items"
						:loading="isLoading"
						color="grey"
						hide-no-data
						hide-selected
						item-text="Description"
						item-value="API"
						label="Osoba do dodania"
						aria-label="contest user"
						for="add-agency-contest-user-menu-person-add"
						id="add-agency-contest-user-menu-person-add"
						placeholder="Wpisz kogo chcesz dodać"
						prepend-icon="mdi-database-search"
						return-object
					></v-autocomplete>
				</v-card-text>
				<v-divider></v-divider>
				<v-expand-transition>
					<v-list v-if="model" class="grey lighten-2">
						<v-list-tile
							v-for="(field, i) in fields"
							:key="i"
						>
							<v-list-tile-content v-if="field.key !== 'id'">
								<v-list-tile-title v-text="field.value"></v-list-tile-title>
								<v-list-tile-sub-title v-text="field.key"></v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-expand-transition>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:disabled="!model"
						color="primary"
						@click="$emit('save',model.id); model = null; dialog = false;"
					>
						zapisz
					</v-btn>
					<v-btn
						:disabled="!model"
						color="primary"
						@click="model = null"
					>
						resetuj
					</v-btn>


					<v-btn
						color="blue"
						@click="dialog = false; model = null"
					>
						anuluj
					</v-btn>

				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

	export default {
		name: "AddAgencyContestUserMenu",
		data() {
			return {
				dialog: false,
				user: [],
				model: null,
				isLoading: false,
			};
		},

		computed: {
			fields() {
				if (!this.model) return [];

				return Object.keys(this.model).filter((key) => key !== "id")
					.map(key => {
						return {
							key: key === "name" ? "Imię" :
								key === "surname" ? "Nazwisko" :
								key === "email" ? "Adres e-mail" :
								key === "role" ? "Rola" :
								key === "Description" ? "Opis" :
								key,
							value: this.model[key] || "-",
						};
					});
			},
			items() {
				return this.possibilities.map(entry => {
					const Description = entry.name + " " + entry.surname;

					return Object.assign({}, entry, {Description});
				});
			},
		},

		props: {
			possibilities: Array,
		},
	};
</script>

<style scoped>
	.theme--dark .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
		color: #fff !important;
		background-color: #000 !important;
	}

	.theme--dark .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
		color: #fff !important;
		border: solid 2px yellow !important;
	}


</style>
